<script>
// Inputs
import FileInput from './inputs/File';
import RadioInput from './inputs/Radio';
import SelectInput from './inputs/Select';
import CheckBoxInput from './inputs/CheckBox';
import TextAreaInput from './inputs/TextArea';
import StandardInput from './inputs/StandardInput';
import MultiSelectInput from './inputs/MultiSelect';
import MultipleFileInput from './inputs/MultipleFile';

// Variants
import DatePickerInput from './inputs/variants/DatePicker';

export default {
    props: {
        input: {
            type: Object,
            required: true,
        },
    },

    render: function (createElement) {
        // Supported input types
        let lookup = {
            // Dibs
            'standard': StandardInput,

            // Common
            'checkbox': CheckBoxInput,
            'file': FileInput,
            'multiplefile': MultipleFileInput,
            'password': StandardInput,
            'radio': RadioInput,
            'select': SelectInput,
            'multiselect': MultiSelectInput,
            'text': StandardInput,
            'textarea': TextAreaInput,

            // HTML 5
            'color': StandardInput,
            'date': StandardInput,
            'datetime': StandardInput,
            'email': StandardInput,
            'month': StandardInput,
            'number': StandardInput,
            'range': StandardInput,
            'search': StandardInput,
            'tel': StandardInput,
            'time': StandardInput,
            'url': StandardInput,
            'week': StandardInput,

            // Variants
            'datepicker': DatePickerInput,
        };

        // Register each as a component
        Object.keys(lookup).forEach(type => {
            Vue.component(`input-${type}`, lookup[type]);
        });

        // Resolve to a supported type for rendering.
        let type = Object.keys(lookup).includes(this.input.variant)
            ? this.input.variant
            : Object.keys(lookup).includes(this.input.type)
                ? this.input.type
                : 'text';

        // Render input
        return createElement(`input-${type}`, {
            props: this.$props
        });
    },
}
</script>
